import * as Types from "../action.types"
import * as Models from "../../models/index"
import * as Services from "../../service/index"
import * as toastr from "toastr"
export const changeUserPassword = () => (d: Function, gs: () => Models.StoreState) => {
    d({
        type: Types.PWD_EXPIRED_PENDING
    });

    Services.Recovery.changeUserPassword({
        username: gs().login.userName,
        oldPassword: gs().pwdSecurity.oldPassword,
        newPassword: gs().pwdSecurity.password,
        confirmPassword: gs().pwdSecurity.confirmPassword,
        isNeedToChangePwd: gs().login.isNeededToChangePWD
    }).then((result) => {
        if (!result.status) {
            toastr.success(result.message);
            window.location.href = "/login";
        }
        else {
            toastr.warning(result.message)
        }
    })
}